<template>
  <th v-bind="column.th">
    <slot
      :name="slotName1"
      v-bind="{handler: {sort: sort, resize: handleMouseDown}}">

      <span>

        <slot
          :name="slotName2"
          v-bind="{handler: {sort: sort, resize: handleMouseDown}}">
          {{column.text}}
        </slot>

      </span>

      <switch-table-sort
        v-if="column.isSortable"
        class="v-table-wrapper-column-sort"
        :state="state"
        @click.native="sort">
      </switch-table-sort>
      <v-icon
        v-if="column.isResizable"
        class="v-table-wrapper-column-drag"
        @mousedown="handleMouseDown">
        mdi-drag
      </v-icon>

    </slot>
  </th>
</template>

<script>
  import {store} from '../store'
  import SwitchTableSort from './SwitchTableSort'

  export default {
    name: 'HeaderCellDefault',
    components: {SwitchTableSort},
    props: {
      column: Object,
      type: String,
      index: Number,
      multiSort: Boolean
    },
    methods: {
      sort() {
        store.state.sortEvents.map(sortEvent => sortEvent(this.column.value));
        store.dispatch('clickSort', {key: this.column.value, multiSort: this.multiSort})
      },
      handleMouseDown(eventMouseDown) {
        const minWidthColumn = 25;
        const type = this.type;

        eventMouseDown.target.setAttribute('state', 'active');
        const {cellIndex} = eventMouseDown.target.closest('th, td');
        const beginWidth = eventMouseDown.target.closest('th, td').offsetWidth;
        const beginX = eventMouseDown.clientX;

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        function handleMouseMove(eventMouseMove) {

          const endX = eventMouseMove.clientX;

          let endWidth = beginWidth + endX - beginX;
          endWidth = (endWidth >= minWidthColumn)
            ? endWidth
            : minWidthColumn;

          store.dispatch('setWidthCol', {type, index: cellIndex, value: endWidth})
        }

        function handleMouseUp() {
          eventMouseDown.target.setAttribute('state', '');
          document.removeEventListener('mousemove', handleMouseMove);
          document.removeEventListener('mouseup', handleMouseUp)
        }
      }
    },
    computed: {
      state() {
        return store.state.sortStates[this.column.value]
      },
      slotName1() {
        return (this.$scopedSlots[`header.${this.column.value}`]) ? `header.${this.column.value}` : undefined
      },
      slotName2() {
        return (this.$scopedSlots[`header.text.${this.column.value}`]) ? `header.text.${this.column.value}` : undefined
      }
    },
    mounted() {
      store.commit('changeByKeySortState', {value: 0, key: this.column.value});
      if (this.type === 'common') {
        store.dispatch('setWidthCol', {value: this.$el.offsetWidth, index: this.index, type: this.type})
      }
    }
  }
</script>

<style lang="scss" scoped>
  th {
    position: relative;
    overflow: hidden;
    white-space: nowrap;

    .v-table-wrapper-column-drag {
      display: none;
      cursor: col-resize;
      height: 1em;
      position: absolute;
      bottom: calc(50% - 0.5em);
      top: calc(50% - 0.5em);
      right: 0;
    }

    &:hover .v-table-wrapper-column-drag {
      display: inline;
    }

    .v-table-wrapper-column-sort {
      display: none;
    }

    .v-table-wrapper-column-sort[state="active"],
    &:hover .v-table-wrapper-column-sort {
      display: inline;
    }
  }
</style>
